import { Box, styled } from '@mui/material';
import { ActionNodeData } from '../../../mappers/map-canvas-content.types';

export const ActionNodeContent = ({ data }: { data: ActionNodeData }) => {
  switch (data.actionType) {
    case 'forwardToPartners': {
      const partners = data.value;
      const isPopulated = partners.length > 0;

      if (!isPopulated) {
        return <Description>Configure this node to forward shifts to partners.</Description>;
      }

      return (
        <ContentWrapper>
          <Description>Affected shifts will be forwarded to these partners:</Description>
          <PillsWrap>
            {partners.map((partner) => (
              <Pill key={partner.value}>{partner.label}</Pill>
            ))}
          </PillsWrap>
        </ContentWrapper>
      );
    }

    default:
      return <Description>Unknown action type.</Description>;
  }
};

const ContentWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

const Description = styled(Box)(() => ({
  fontSize: 10,
}));

const PillsWrap = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(2),
}));

const Pill = styled('span')(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.spacing(2),
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  fontSize: 10,
  lineHeight: 1.4,
  whiteSpace: 'nowrap',
}));
